/**
 * Maps Import Data “upload file type” to Angular `CompanyChangesComponent` `selectedtype`.
 * Only these types use the detail comparison dialog (`showChanges`).
 */
import type { AlnImportViewKind, ImportDataType } from '../types'

export type { AlnImportViewKind } from '../types'

export function mapImportTypeToViewKind(type: ImportDataType): AlnImportViewKind | null {
  switch (type) {
    case 'management_company':
      return 'company_change'
    case 'manager_change':
      return 'manager_change'
    case 'area_supervisor':
      return 'area_supervisor'
    case 'pmc_import':
      return 'pmc_import'
    case 'property_import':
      return 'property_import'
    default:
      return null
  }
}

export function importTypeHasDetailView(type: ImportDataType): boolean {
  return mapImportTypeToViewKind(type) != null
}
